import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  verifyToken: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: false,
  },
};

export const verifyTokenSlice = createSlice({
  name: "verifyToken",
  initialState: INITIAL_STATE,
  reducers: {
    fetchVerifyToken: (state) => {
      state.verifyToken.isLoading = true;
    },
    fetchVerifyTokenSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      verifyToken: {
        ...state.verifyToken,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchVerifyTokenFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      verifyToken: {
        ...state.verifyToken,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
  },
});

export const {
  fetchVerifyToken,
  fetchVerifyTokenSuccess,
  fetchVerifyTokenFailure,
} = verifyTokenSlice.actions;
export const verifyTokenReducer = verifyTokenSlice.reducer;
